import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate  {
  constructor(private router: Router, private userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.userService.isAdminAuthorized) {
      this.userService.tryToGetAdmin();
      return true;
    }
    this.router.navigate(['auth/login']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthLoginGuard implements CanActivate  {
  constructor(private router: Router,
              private userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.userService.isAdminAuthorized) {
      return true;
    }
    this.router.navigate(['/admin']);
    return false;
  }
}
